import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";
import {EnumFiltroDePedidos} from "./pedidos.service";

export interface ResultadoValidacaoComanda {
  id: number;
  codigo: string;
  mesa: {id: number, nome: string} | null;
  valor: number;
  paga: boolean;
  situacao: 'PAGA' | 'PENDENTE';
  statusComanda: string;
  validadaEm: string;
}

@Injectable({
  providedIn: 'root'
})
export class ComandaService extends ServerService {

  constructor(http: HttpClient) {
    super(http);
  }

  liste() {
    return this.obtenha('/comandas/liste', { });
  }

  obtenhaComanda(idComanda: string) {
    return this.obtenha('/comandas/obtenha?idc=' + idComanda, {});
  }

  obtenhaMesa(idMesa: string) {
    return this.obtenha('/comandas/mesa?idm=' + idMesa, {});
  }

  validePagamento(codigo: string): Promise<ResultadoValidacaoComanda> {
    return this.facaPost('/comandas/validar-pagamento', {codigo});
  }

  trocarMesaComanda(idComanda: string, mesa: any) {
    return this.facaPost('/comandas/trocar-mesa', {
      idc: idComanda,
      idnm: mesa.id
    });
  }

  reabraComanda(comanda: any) {
    return this.facaPost(String(`/comandas/${comanda.id}/reabra`), {});
  }

  atualizeDesconto(comanda: any, desconto: number) {
    return this.facaPost(String(`/comandas/${comanda.id}/desconto`), {desconto: desconto});
  }

  marqueComoLido(comanda: any){
    return this.facaPost(String(`/comandas/${comanda.id}/marquelida`), {});
  }

  altereItemPedido(comanda: any, pedido: any, itemAtualizado: any) {
    return this.facaPut(`/comandas/${comanda.id}/${pedido.guid}/item`, itemAtualizado)
  }

  gerePixOnlineTuna(comanda: any, dados: any) {
    return this.facaPost(`/comandas/${comanda.id}/pix-online-tuna`, dados);
  }

  cancelePixOnlineTuna(comanda: any, pagamento: any) {
    return this.facaPost(`/comandas/${comanda.id}/pix-online-tuna/${pagamento.id}/cancele`, {});
  }

  sincronizePixOnlineTuna(comanda: any, pagamento: any, forcar: boolean = false) {
    const params = forcar ? {forcar: 'true'} : {};

    return this.obtenha(`/comandas/${comanda.id}/pix-online-tuna/${pagamento.id}/sincronize/${pagamento.statusNumero}`, params);
  }

  // Rodízio: situação da comanda (código sai ao lançar o plano; paga no fechamento) e troca de código
  obtenhaRodizio(idComanda: any) {
    return this.obtenha(`/comandas/${idComanda}/rodizio`, {});
  }

  gereNovoCodigoRodizio(idComanda: any) {
    return this.facaPost(`/comandas/${idComanda}/rodizio/novo-codigo`, {});
  }


}
